import React from 'react';
import LocationPoint from '../../content/LocationPoint';

export const AutocompleteMatchTestId = 'AutocompleteMatch-input';

export type AutocompleteMatchProps = {
  description: string;
  onClick: () => void;
};

const AutocompleteMatch: React.FC<AutocompleteMatchProps> = ({
  description,
  onClick,
}: AutocompleteMatchProps) => {
  const descriptionSegments = description.split(',');
  const primaryAddressText = descriptionSegments[0];
  const secondaryAddressText = descriptionSegments
    .join(',')
    .replace(primaryAddressText, '');
  return (
    <div
      className="flex flex-row space-x-1 cursor-pointer"
      data-testid={AutocompleteMatchTestId}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={onClick}
    >
      <div className="flex-0 self-center">
        <LocationPoint />
      </div>
      <div className="text-xs self-center w-full">
        <span>{primaryAddressText}</span>
        <span>{secondaryAddressText}</span>
      </div>
    </div>
  );
};

export default AutocompleteMatch;
